import React from 'react';

import moment from 'moment';
import { Table } from 'antd/lib';

import { imprimirReporteEnvio } from '../../common/funciones/imprimirReporte';

class TablaMostrarIngresos extends React.Component {
  render() {
    // console.log('DATOS: ', this.props.data);
    const colums = [
      {
        title: 'N°',
        dataIndex: 'numero',
        key: 'numero',
        render: numero => <p style={{ fontSize: 12 }}> {numero} </p>,
        align: 'center',
        defaultSortOrder: 'descend',
        sorter: (a, b) => b.numero - a.numero,
      },
      {
        title: 'Fecha Envio',
        key: 'fechaEnvio',
        render: record => (
          <p style={{ fontSize: 12 }}>
            {record.fechaEnvio
              ? moment(record.fechaEnvio).format('DD/MM/YYYY')
              : 'SIN DATOS'}
          </p>
        ),
        align: 'center',
      },
      {
        title: 'Fecha Arrivo',
        key: 'fechaArrivo',
        render: record => (
          <p style={{ fontSize: 12 }}>
            {record.fechaArrivo
              ? moment(record.fechaArrivo).format('DD/MM/YYYY')
              : 'SIN DATOS'}
          </p>
        ),
        align: 'center',
      },
      {
        title: 'Estado del Envio',
        dataIndex: 'estado',
      },
      {
        title: 'Remitente',
        dataIndex: 'remitente.nombre',
      },
    ];
    // console.log(this.props.fechaInicio);
    // console.log(this.props.fechaFin)
    let fGeneracion = moment(new Date()).format('DD/MM/YYYY HH:mm');

    // console.log(fInicio);
    // console.log(fFin);

    return (
      <div>
        <Table
          onRow={record => {
            // console.log("El registro es..");
            // console.log(record);
            return {
              onClick: () => imprimirReporteEnvio(fGeneracion, record), // click row
            };
          }}
          bordered
          pagination={false}
          style={{ maxWidth: 900, marginLeft: '10%', marginTop: 20 }}
          dataSource={this.props.data}
          columns={colums}
        />
      </div>
    );
  }
}

export default TablaMostrarIngresos;
